import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { getResponsiveSize } from "../../utils/responsive";
import globalStyles from "../../global";

const Banner = ({ slides }) => {

  return (
    <Box sx={styles.mainBox}>
      <Box sx={styles.innerBox}>
        <Box sx={styles.rightBox}>
          <Box sx={styles.titleWrapper}>
            <Typography sx={styles.title}>
              MAKING LAUNDRY
              <br />
              & DRY-CLEANING EASY,
              <br />
              <Box component="span" sx={styles.titleSpan}>
                WORLDWIDE.
              </Box>
            </Typography>
          </Box>

          <Box sx={styles.subTitleWrapper}>
            <Typography sx={styles.subTitle}>
              Efficient, quick and eco-friendly cleaning services wherever you are!
            </Typography>
          </Box>

          <Box sx={styles.buttonContainer}>
            <Button
              sx={styles.registerButton}
              href="https://play.google.com/store/apps/details?id=com.ucleanlaundry&hl=en_IN&pli=1"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download The App
            </Button>
            {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
              <Button sx={styles.registerButton}>
                💚 ORDER NOW
              </Button>
              <Button 
                variant="outlined" 
                sx={{
                  ...styles.registerButton,
                  backgroundColor: 'transparent',
                  border: `2px solid ${globalStyles.colors.army_green}`,
                  color: globalStyles.colors.army_green,
                  '&:hover': {
                    backgroundColor: globalStyles.colors.army_green,
                    color: globalStyles.colors.white,
                  }
                }}
              >
                EXPLORE SERVICES
              </Button>
            </Stack> */}
          </Box>

          {/* Carousel dots indicator */}
          {/* <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, gap: 1 }}>
            <Box sx={{ 
              width: 8, 
              height: 8, 
              borderRadius: '50%', 
              backgroundColor: globalStyles.colors.uclean_gold,
              opacity: 1 
            }} />
            <Box sx={{ 
              width: 8, 
              height: 8, 
              borderRadius: '50%', 
              backgroundColor: globalStyles.colors.uclean_gold,
              opacity: 0.6 
            }} />
            <Box sx={{ 
              width: 8, 
              height: 8, 
              borderRadius: '50%', 
              backgroundColor: globalStyles.colors.uclean_gold,
              opacity: 0.3 
            }} />
          </Box> */}
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  mainBox: {
    height: {
      xs: "400px", // mobile
      sm: "440px", // tablets
      md: "500px", // laptops/desktops
    },
    width: '100%',
    py: { xs: 2, sm: 6 },
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    overflow: "hidden",
    display: "flex",
    background: "linear-gradient(135deg, #e8f0e3 0%, #f5f8f2 100%)",
  },
  innerBox: {
    display: "flex",
    flexDirection: {
      xs: "column",
      md: "row",
    },
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },

  rightBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: { xs: getResponsiveSize(4), md: 10 },
    marginBottom: { xs: getResponsiveSize(8), md: 10 },
    width: {
      xs: "90%",
      md: "80%",
    },
    maxWidth: "800px",
  },

  titleWrapper: {
    width: "100%",
    textAlign: "center",
    mb: { xs: 2, sm: 3 },
  },

  title: {
    color: "#2c5530",
    fontFamily: globalStyles.fonts.primaryGlobal,
    fontWeight: 800,
    lineHeight: 1.1,
    textAlign: "center",
    fontSize: {
      xs: "32px", // Reduced font size for mobile
      sm: "38px",
      md: "60px",
    },
  },
  titleSpan: {
    fontFamily: globalStyles.fonts.primaryGlobal,
    fontWeight: 800,
    display: "inline",
    textAlign: "left",
    color: globalStyles.colors.uclean_green || "#4caf50",
    fontSize: {
      xs: "32px", // Reduced font size for mobile
      sm: "38px",
      md: "60px",
    },
  },

  subTitleWrapper: {
    width: "100%",
    textAlign: "center",
    mb: { xs: 3, sm: 4 },
  },

  subTitle: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 400,
    fontSize: { xs: "12px", sm: "18px", md: "18px" },
    color: "#666",
    lineHeight: 1.4,
  },
  infoStack: {
    flexDirection: {
      xs: "column",
      sm: "row",
    },
    justifyContent: {
      xs: "center", // Center on mobile
      sm: "space-evenly",
    },
    alignItems: "center",
    mb: { xs: 3, sm: 4 },
    rowGap: { xs: 2, sm: 0 },
    // Make sure the stack takes up full width on mobile
    width: { xs: "100%", sm: "auto" },
  },

  infoItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    // Make sure each info item takes up full width on mobile
    width: {
      xs: "100%",
      sm: "auto", // Let it shrink or grow as needed on larger screens
    },
    // Add horizontal padding on mobile so text isn't too close to edges
    px: { xs: 2, sm: 0 },
  },

  infoText: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 400,
    color: globalStyles.colors.white,
    ml: "4px",
    fontSize: {
      xs: getResponsiveSize(12), // Reduced font size for mobile
      sm: getResponsiveSize(16),
      md: getResponsiveSize(18),
    },
    textAlign: "left",
    // Add text wrapping on mobile
    whiteSpace: { xs: "normal", sm: "nowrap" },
  },

  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mb: 4,
  },

  registerButton: {
    borderRadius: "10px",
    backgroundColor: globalStyles.colors.uclean_green,
    color: globalStyles.colors.white || "#ffffff",
    fontSize: {
      xs: getResponsiveSize(15),
      sm: getResponsiveSize(16),
      md: getResponsiveSize(18),
    },
    fontFamily: ' "Poppins", serif ',
    fontWeight: 600,
    width: {
      xs: "200px", // Full width on mobile
      sm: "220px", // Fixed width on tablet
      md: "240px", // Fixed width on desktop
    },
    height: {
      xs: "44px",
      sm: "48px",
      md: "52px",
    },
    px: 0, // Remove horizontal padding since width is fixed
    py: 0,
    "&:hover": {
      color: globalStyles.colors.white || "#ffffff",
      backgroundColor: globalStyles.colors.uclean_green || "#4caf50",
    },
  },
};

export default Banner;
